import React, { useMemo } from 'react';

import { Box, type BoxProps } from '@frontend/legacy-components';

import { CASCADER_SUBCOMPONENT_NAMES } from '../consts';
import { useCascaderState, useCascaderComponentsContext } from '../context';
import type { CascaderOption, CascaderCommonProps } from '../types';

export interface IndicatorsContainerProps<OptionType extends CascaderOption>
  extends BoxProps {
  children: React.ReactNode;
  getCommonProps: () => CascaderCommonProps<OptionType>;
}

export const InternalIndicatorsContainer = <OptionType extends CascaderOption>({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { cascaderStyles, getCommonProps } = useCascaderState<OptionType>();
  const { getComponent } = useCascaderComponentsContext<OptionType>();
  const CustomIndicatorsContainer = useMemo(
    () => getComponent(CASCADER_SUBCOMPONENT_NAMES.INDICATORS_CONTAINER),
    [getComponent],
  );

  return (
    <CustomIndicatorsContainer
      getCommonProps={getCommonProps}
      __css={cascaderStyles.indicatorsContainer}
      className="cascader-indicators-container"
    >
      {children}
    </CustomIndicatorsContainer>
  );
};

export const IndicatorsContainer = <OptionType extends CascaderOption>({
  children,
  getCommonProps: _,
  ...rest
}: IndicatorsContainerProps<OptionType>) => {
  return <Box {...rest}>{children}</Box>;
};
